<app-deal-navbar></app-deal-navbar>
<!-- MAIN -->
<section *ngIf="transaction">
  <aside class="allDetails">
    <div class="paymentDetails">
      <div class="info">
        <!-- <div class="logo">
          <img src="../../../../assets/image/VTB/VTB_logo.jpg" alt="Company Logo">
        </div> -->
        <div class="company-name">
          <div class="logo">
            <!-- <img src="{{domSanitizer.bypassSecurityTrustUrl(transaction?.qrImage)}}" alt="Company Logo"> -->
            <img *ngIf="changeMerchantLogo(transaction?.logo)" [src]="transaction?.logo" alt="Company Logo">
            <img *ngIf="!changeMerchantLogo(transaction?.logo)" src="../../../../assets/image/default/Default.jpg" alt="Default Logo">
          </div>
          <!-- <h2>Congress Hotel</h2> -->
          <h2>{{transaction.merchantName}}</h2>
        </div>
      </div>
      <div class="payment hide-block-for-pay">
        <div class="details line">
          <div class="comment" *ngIf="transaction.status ==''">
            <span>{{transaction.comment}}</span>
          </div>
          <div class="amount">
            <span>{{transaction.amount}} AMD</span>
          </div>
          <div class="text-seccessful">
            <img src="../../../../../assets/image/user-paid-unpaid/check.png" alt="">
            <span>{{'deals.paid' | translate}}</span>
          </div>
        </div>
        <form class="email" [formGroup]="sendMail" (submit)="sendData()">
          <div class="text">
            <span>{{'deals.send' | translate}}</span>
          </div>
          <div class="email-input">
            <!-- <input type="email" placeholder="Էլ․ փոստ" class="email-field"> -->
            <input type="email" placeholder="{{'deals.mail' | translate}}" class="email-field" formControlName="email">
            <div class="spin" *ngIf="showLoader">
              <div class="spinner-border text-success" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
            </div>
          </div>
          <div class="send-btn">
            <!-- <button>Ուղարկել</button> -->
            <button [disabled]="!sendMail.get('email').valid">{{'deals.sendButton' | translate}}</button>
          </div>
        </form>
      </div>
    </div>
  </aside>
  <!-- <aside class="ad-banner">
    <div class="banner-div">
      <img src="../../../../../assets/image/user-paid-unpaid/banner.jpg" alt="">
    </div>
  </aside> -->
</section>
<!-- FOOTER -->
<footer>
  <div class="loader" *ngIf="showLoaderBig">
    <div class="lds-roller">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </div>


</footer>
